module.exports = __webpack_public_path__ + "static/img/bz.c8bbbc61.png";